import { partnerHasSession } from "../Login/partnerHasSession";

export function init() {
  partnerHasSession({});
}
